export const ASP_ACCREDIATION_NUMBER = import.meta.env.VITE_ASP_ACCREDIATION_NUMBER;
export const ASP_NAME = import.meta.env.VITE_ASP_NAME;
export const SERVICE_PROVIDER_ID = import.meta.env.VITE_SERVICE_PROVIDER_ID;
export const SMP_ACCESSPOINT_ID = import.meta.env.VITE_SMP_ACCESSPOINT_ID;
